import React, { createContext, useContext } from "react";
import { useLessonService } from "./LessonService";
import { useAuthService } from "./AuthService";
// import { useNotificationService } from "./NotificationService";

export const ServiceContext = createContext(null);

export const ServiceProvider = ({ children }) => {
  const auth = useAuthService();
  const lesson = useLessonService(auth);
  // const suUserService = useSuperUserUserService

  const services = {
    lesson,
  };

  return (
    <ServiceContext.Provider value={services}>
      {children}
    </ServiceContext.Provider>
  );
};

export const useServices = () => useContext(ServiceContext);
